import AddIcon from "@mui/icons-material/Add";
import {
	Box,
	Button,
	DataGrid,
	FlexColumn,
} from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React from "react";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import ExplorationsListItem from "../explorationsListItem/ExplorationsListItem";

const ExplorationsList = observer(() => {
	const fashionInspirationStore = useManageFashionInspirationStore();
	const {
		setOpenNewExplorationDialog,
		explorationsStore,
	} = fashionInspirationStore;

	return (
		<FlexColumn overflow="hidden">
			<FlexColumn overflow="auto" p={4}>
				<DataGrid
					CardComponent={ExplorationsListItem}
					columns={1}
					spacing={2}
					store={explorationsStore}
				/>
			</FlexColumn>
			<Box
				alignItems="center"
				borderTop={STANDARD_BORDER_STYLE}
				display="flex"
				justifyContent="center"
				p={4}
			>
				<Button
					design="primary"
					onClick={setOpenNewExplorationDialog}
					res="NewExplorationButton"
					startIcon={<AddIcon />}
				/>
			</Box>
		</FlexColumn>
	);
});

export default ExplorationsList;
